module.exports = __webpack_public_path__ + "static/media/word.29e9e5fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/word.png
// module id = 1197
// module chunks = 114